import {
    GET_GCP_ALERTS,
    GET_GCP_ALERTS_FAIL,
    GET_GCP_ALERTS_SUCCESS,
    GET_GCP_RESOURCE_BY_RESOURCE_ID,
    GET_GCP_RESOURCE_BY_RESOURCE_ID_FAIL,
    GET_GCP_RESOURCE_BY_RESOURCE_ID_SUCCESS,
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID,
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_FAIL,
    GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    POST_DISABLE_GCP_ALERTS,
    POST_DISABLE_GCP_ALERTS_FAIL,
    POST_DISABLE_GCP_ALERTS_SUCCESS,
    POST_ENABLE_GCP_ALERTS,
    POST_ENABLE_GCP_ALERTS_FAIL,
    POST_ENABLE_GCP_ALERTS_SUCCESS,
    PUT_GCP_ALERTS,
    PUT_GCP_ALERTS_FAIL,
    PUT_GCP_ALERTS_SUCCESS,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_FAIL,
    POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_SUCCESS,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_FAIL,
    POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_SUCCESS,
} from "./actionTypes";

export const getGCPAlerts = data => ({
    type: GET_GCP_ALERTS,
    payload: data,
})

export const getGCPAlertsSuccess = gcp_alerts => ({
    type: GET_GCP_ALERTS_SUCCESS,
    payload: gcp_alerts,
})

export const getGCPAlertsFail = error => ({
    type: GET_GCP_ALERTS_FAIL,
    payload: error,
})

export const getGCPResourceByResourceID = data => ({
    type: GET_GCP_RESOURCE_BY_RESOURCE_ID,
    payload: data
})

export const getGCPResourceByResourceIDSuccess = gcp_resource => ({
    type: GET_GCP_RESOURCE_BY_RESOURCE_ID_SUCCESS,
    payload: gcp_resource,
})

export const getGCPResourceByResourceIDFail = error => ({
    type: GET_GCP_RESOURCE_BY_RESOURCE_ID_FAIL,
    payload: error,
})

export const getDefaultGCPThresholdByMonitoredResourceID = data => ({
    type: GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID,
    payload: data
})

export const getDefaultGCPThresholdByMonitoredResourceIDSuccess = default_threshold_gcp_resource => ({
    type: GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
    payload: default_threshold_gcp_resource,
})

export const getDefaultGCPThresholdByMonitoredResourceIDFail = error => ({
    type: GET_DEFAULT_GCP_THRESHOLD_BY_RESOURCE_ID_FAIL,
    payload: error,
})

export const getMissingGCPAlertsByResourceID = data => ({
    type: GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID,
    payload: data
})

export const getMissingGCPAlertsByResourceIDSuccess = gcp_resource_missing_alerts => ({
    type: GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
    payload: gcp_resource_missing_alerts,
})

export const getMissingGCPAlertsByResourceIDFail = error => ({
    type: GET_GCP_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
    payload: error,
})

export const postDisableGCPAlerts = (data) => ({
    type: POST_DISABLE_GCP_ALERTS,
    payload: { data }
})

export const postEnableGCPAlerts = (data) => ({
    type: POST_ENABLE_GCP_ALERTS,
    payload: { data }
})

export const postDisableGCPAlertsSuccess = gcp_alerts => ({
    type: POST_DISABLE_GCP_ALERTS_SUCCESS,
    payload: gcp_alerts,
})

export const postEnableGCPAlertsSuccess = gcp_alerts => ({
    type: POST_ENABLE_GCP_ALERTS_SUCCESS,
    payload: gcp_alerts,
})

export const postEnableGCPAlertsFail = error => ({
    type: POST_ENABLE_GCP_ALERTS_FAIL,
    payload: error,
})

export const postDisableGCPAlertsFail = error => ({
    type: POST_DISABLE_GCP_ALERTS_FAIL,
    payload: error,
})

export const putGCPAlerts = (data) => ({
    type: PUT_GCP_ALERTS,
    payload: { data }
})

export const putGCPAlertsSuccess = gcp_alerts => ({
    type: PUT_GCP_ALERTS_SUCCESS,
    payload: gcp_alerts,
})

export const putGCPAlertsFail = error => ({
    type: PUT_GCP_ALERTS_FAIL,
    payload: error,
})

export const postSpecificGCPResourceServiceMapping = data => ({
    type: POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING,
    payload: { data }
})

export const postSpecificGCPResourceServiceMappingSuccess = gcp_resource => ({
    type: POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_SUCCESS,
    payload: gcp_resource,
})

export const postSpecificGCPResourceServiceMappingFail = error => ({
    type: POST_SPECIFIC_GCP_RESOURCE_SERVICE_MAPPING_FAIL,
    payload: error,
})

export const postSpecificGCPCreateResourceAlerts = (data) => ({
    type: POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS,
    payload: { data }
})

export const postSpecificGCPCreateResourceAlertsSuccess = (gcp_alerts) => ({
    type: POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_SUCCESS,
    payload: gcp_alerts
})

export const postSpecificGCPCreateResourceAlertsFail = error => ({
    type: POST_SPECIFIC_GCP_CREATE_RESOURCE_ALERTS_FAIL,
    payload: error,
})